<script setup lang="ts">
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import jaJP from "@/locales/ja-JP.json";
import enUS from "@/locales/en-US.json";
import { useTaskStore } from "@/store/task";
import TaskEntry from "./TaskEntry.vue";

type MessageSchema = typeof jaJP;

const { t } = useI18n<{
  message: MessageSchema
}, "ja-JP" | "en-US">({
  inheritLocale: true,
  messages: {
    "ja-JP": jaJP,
    "en-US": enUS,
  }
});

const taskStore = useTaskStore();
const daily = ref(taskStore.dailyTaskCompleteInfo);
const weekly = ref(taskStore.weeklyTaskCompleteInfo);

watch(() => taskStore.ready, () => {
  daily.value = taskStore.dailyTaskCompleteInfo;
  weekly.value = taskStore.weeklyTaskCompleteInfo;
});
</script>

<template>
  <article>
    <header>
      <h2>{{ t("tasks.daily") }}</h2>
    </header>
    <ul class="task-list">
      <li
        v-for="task in daily"
        :key="task.id"
      >
        <TaskEntry :task="task" />
      </li>
    </ul>
  </article>
  <article>
    <header>
      <h2>{{ t("tasks.weekly") }}</h2>
    </header>
    <ul class="task-list">
      <li
        v-for="task in weekly"
        :key="task.id"
      >
        <TaskEntry :task="task" />
      </li>
    </ul>
  </article>
</template>

<style scoped lang="scss">
@import "@/assets/sass/mixin.scss";

article {
  margin: 0 .5rem;
}
h2 {
  padding-left: .5rem;
  border-bottom: 1px solid rgba(255, 255, 255, .125);
  font-size: 1.25rem;
  color: #97E2FC;
}
.task-list {
  list-style: none;
  padding-left: 1rem;
  li {
    margin-top: 2px;
    background-color: rgba(0, 0, 0, .125);
  }
}

@include mq(sp) {
  .task-list {
    padding: 0 .5rem;
    li:not(:first-child) {
      margin-top: .5rem;
    }
  }
}
</style>
